import { render, staticRenderFns } from "./LiveSidePanel.vue?vue&type=template&id=4df417bc"
import script from "./LiveSidePanel.vue?vue&type=script&lang=ts"
export * from "./LiveSidePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports